define(
({
  "load_error": "Erreur de chargement",
  "description": "Une demande n'a pas été terminée correctement. Vous devriez vous assurer que votre commande soit enregistrée puis actualiser cette page."
})
);
